import { Action, sidebarOptionPayload, sidebarOptionState } from "../../types"

const initialState:sidebarOptionState = {
    visibleSidebarOptions:[],
    activeOption:"",
    sidebarCollapsed: false
}
export function sidebarOptionsReducer(state:sidebarOptionState=initialState,action:Action<sidebarOptionPayload>):sidebarOptionState{
    switch(action.type){
        case "toggleSidebarCollapsed":
            return {...state,...action.payload};
        case "resetSidebarOptions":
            return {...state,...action.payload};
        case "setActiveSidebar":
            return {
                ...state,
                "activeOption":action.payload.activeOption ?? ""
            };
    }
    return state
}